<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h4 class="mb-0 text-primary">Clientes</h4>
      <!-- Botón para agregar un nuevo cliente -->
      <button class="btn btn-primary" @click="nuevoCliente">
        <i class="fas fa-plus"></i> Agregar Cliente
      </button>
      <Preloader :visible="cargando" />
    </div>
    <!-- Tablas -->
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-4">
        <table class="table table-bordered table-striped mb-0" ref="itemtabla">
          <thead>
            <tr class="text-uppercase">
              <th class="text-start px-3 py-2">ID Cliente</th>
              <th class="text-start px-3 py-2">Nombre</th>
              <th class="text-start px-3 py-2">Correo</th>
              <th class="text-center px-3 py-2">Teléfono</th>
              <th class="text-center px-3 py-2">Estado</th>
              <th class="text-center px-3 py-2">Fecha de Registro</th>
              <th class="text-center px-3 py-2">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cliente in clientes" :key="cliente.id">
              <td class="text-start">{{ cliente.id }}</td>
              <td class="text-start">{{ cliente.nombres }}</td>
              <td class="text-start">{{ cliente.correo }}</td>
              <td class="text-center">{{ cliente.telefono }}</td>
              <td class="text-center">
                <span
                  :class="[
                    'badge',
                    cliente.estado == 1 ? 'bg-success' : 'bg-secondary',
                  ]"
                >
                  {{ cliente.estado == 1 ? "Activo" : "Inactivo" }}
                </span>
              </td>
              <td class="text-center">
                {{ formatFecha(cliente.fecha_registro) }}
              </td>
              <td
                class="text-center d-flex gap-2 justify-content-center align-items-center"
              >
                <button
                  @click="verClientes(cliente)"
                  class="badge badge-sm bg-gradient-success"
                >
                  <i class="far fa-eye" aria-hidden="true"></i>
                </button>
                <button
                  @click="editarClientes(cliente)"
                  class="badge badge-sm bg-gradient-warning"
                >
                  <i class="far fa-edit" aria-hidden="true"></i>
                </button>
                <button
                  @click="toggleEstado(cliente)"
                  :class="[
                    'badge',
                    'badge-sm',

                    cliente.estado == 1
                      ? 'bg-gradient-danger'
                      : 'bg-gradient-info',
                  ]"
                  :title="cliente.estado == 1 ? 'Desactivar' : 'Activar'"
                >
                  <i
                    :class="
                      cliente.estado == 1 ? 'far fa-trash-altfar fa-trash-alt' : 'fas fa-check'
                    "
                    aria-hidden="true"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal para crear o editar una categoría -->
    <div
      class="modal fade"
      id="principalModal"
      tabindex="-1"
      aria-labelledby="principalModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Cabecera del modal que muestra el título dinámico -->
          <div class="modal-header">
            <h5 class="modal-title" id="principalModalLabel">
              {{ modalTitle }}
            </h5>
            <!-- Botón para cerrar el modal -->
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            ></button>
          </div>
          <!-- Cuerpo del modal con el formulario para nombre, descripción e imagen -->
          <div class="modal-body">
            <form @submit.prevent="guardarClientes">
              <div class="mb-3">
                <div class="mb-3">
                  <label for="logo" class="form-label"> Logo</label>
                  <input
                    type="file"
                    class="form-control"
                    @change="handleFileUpload_logo"
                    ref="logoInput"
                  />
                  <div class="text-danger">{{ formErrors.logo }}</div>
                  <div v-if="form.logo" class="mt-2">
                    <img
                      :src="form.logo"
                      alt="Imagen del cliente"
                      width="100"
                    />
                  </div>
                </div>
                <div class="mb-3">
                  <label for="nombres" class="form-label"
                    >Nombre del cliente</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="nombres"
                    v-model="form.nombres"
                  />
                  <!-- Mensaje de error para el campo 'nombre' -->
                  <div class="text-danger">{{ formErrors.nombres }}</div>
                </div>
                <div class="mb-3">
                  <label for="correo" class="form-label">Correo</label>
                  <input
                    type="email"
                    class="form-control"
                    id="correo"
                    v-model="form.correo"
                  />
                  <div class="text-danger">{{ formErrors.correo }}</div>
                </div>
                <div class="mb-3">
                  <label for="telefono" class="form-label">Teléfono</label>
                  <input
                    type="text"
                    class="form-control"
                    id="telefono"
                    v-model="form.telefono"
                  />
                  <div class="text-danger">{{ formErrors.telefono }}</div>
                </div>
                <div class="mb-3">
                  <label for="fecha_registro" class="form-label"
                    >Fecha de Registro</label
                  >
                  <input
                    type="date"
                    class="form-control"
                    id="fecha_registro"
                    v-model="form.fecha_registro"
                  />
                  <div class="text-danger">{{ formErrors.fecha_registro }}</div>
                </div>

                <div class="mb-3">
                  <label for="numero_documento" class="form-label"
                    >Número de Documento</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="numero_documento"
                    v-model="form.numero_documento"
                  />
                  <div class="text-danger">
                    {{ formErrors.numero_documento }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="direccion" class="form-label">Dirección</label>
                  <input
                    type="text"
                    class="form-control"
                    id="direccion"
                    v-model="form.direccion"
                  />
                  <div class="text-danger">{{ formErrors.direccion }}</div>
                </div>
                <div>
                  <h6>Botón 01</h6>
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.boton_1"
                      placeholder="Texto del Botón 1"
                    />
                    <div class="text-danger">{{ formErrors.boton_1 }}</div>
                  </div>
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.link_boton_1"
                      placeholder="Ingrese el Link del Botón 1"
                    />
                    <div class="text-danger">{{ formErrors.link_boton_1 }}</div>
                  </div>
                  <hr />
                  <h6>Botón 02</h6>
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.boton_2"
                      placeholder="Texto del Botón 2"
                    />
                    <div class="text-danger">{{ formErrors.boton_2 }}</div>
                  </div>
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.link_boton_2"
                      placeholder="Ingrese el Link del Botón 2"
                    />
                    <div class="text-danger">{{ formErrors.link_boton_2 }}</div>
                  </div>
                  <hr />
                  <h6>Botón 03</h6>
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.boton_3"
                      placeholder="Texto del Botón 3"
                    />
                    <div class="text-danger">{{ formErrors.boton_3 }}</div>
                  </div>
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.link_boton_3"
                      placeholder="Ingrese el Link del Botón 3"
                    />
                    <div class="text-danger">{{ formErrors.link_boton_3 }}</div>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="link_banner_uno" class="form-label">
                    Banner Uno</label
                  >
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.link_banner_uno"
                      placeholder="TLink Banner 1"
                    />
                    <div class="text-danger">
                      {{ formErrors.link_banner_uno }}
                    </div>
                  </div>
                  <input
                    type="file"
                    class="form-control"
                    @change="handleFileUpload_uno"
                    ref="bannerUnoInput"
                  />
                  <div class="text-danger">{{ formErrors.banner_uno }}</div>

                  <div v-if="form.banner_uno">
                    <img
                      :src="form.banner_uno"
                      alt="Imagen del baner uno"
                      width="100"
                    />
                  </div>
                </div>
                <div class="mb-3">
                  <label for="link_banner_dos" class="form-label">
                    Banner dos</label
                  >
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.link_banner_dos"
                      placeholder="Link de Banner 2"
                    />
                    <div class="text-danger">
                      {{ formErrors.link_banner_dos }}
                    </div>
                  </div>
                  <input
                    type="file"
                    class="form-control"
                    @change="handleFileUpload_dos"
                    ref="bannerDosInput"
                  />
                  <div class="text-danger">{{ formErrors.banner_dos }}</div>
                  <div v-if="form.banner_dos">
                    <img
                      :src="form.banner_dos"
                      alt="Imagen del baner dos"
                      width="100"
                    />
                  </div>
                </div>
                <div class="mb-3">
                  <label for="tipo_cliente" class="form-label"
                    >Tipo de Cliente</label
                  >
                  <select
                    class="form-select"
                    id="tipo_cliente"
                    v-model="form.tipo_cliente"
                  >
                    <option value="">Seleccione un tipo</option>
                    <option value="Colegio">Colegio</option>
                    <option value="Empresa de Capacitación">
                      Empresa de Capacitación
                    </option>
                    <option value="Instituto">Instituto</option>
                    <option value="Universidad">Universidad</option>
                    <option value="Otro">Otro</option>
                  </select>
                  <div class="text-danger">{{ formErrors.tipo_cliente }}</div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="closeModal"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="guardarClientes"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clienteservice from "../../services/Clienteservice";
import Preloader from "../components/Preloader.vue";

export default {
  data() {
    return {
      clientes: [],
      cargando: false,
      form: {
        nombres: "",
        correo: "",
        tipo_cliente: "",
        fecha_registro: "",
        numero_documento: "",
        direccion: "",
        telefono: "",
        logo: "",
        boton_1: "",
        boton_2: "",
        boton_3: "",
        link_boton_1: "",
        link_boton_2: "",
        link_boton_3: "",
        banner_uno: "",
        banner_dos: "",
        link_banner_uno: "",
        link_banner_dos: "",
        estado: 1, // Estado por defecto al crear
      },
      currentItemId: null,
      modalTitle: "",
      formErrors: {},
      file_uno: null,
      file_dos: null,
      file_logo: null,
    };
  },
  created() {
    this.fetchClientes();
  },
  components: {
    Preloader,
  },
  methods: {
    formatFecha(fecha) {
      if (!fecha) return "";
      const date = new Date(fecha);
      return date.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    async toggleEstado(cliente) {
      try {
        this.cargando = true;
        const nuevoEstado = cliente.estado == 1 ? 0 : 1;

        await Clienteservice.updateCliente(cliente.id, {
          _method: "PUT",
          estado: nuevoEstado,
        });

        this.$swal({
          icon: "success",
          title: "Estado actualizado",
          text: `El cliente ahora está ${nuevoEstado == 1 ? "activo" : "inactivo"}`,
        });

        await this.fetchClientes();
      } catch (error) {
        console.error("Error al cambiar estado:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "No se pudo cambiar el estado del cliente",
        });
      } finally {
        this.cargando = false;
      }
    },

    nuevoCliente() {
      this.modalTitle = "Crear Cliente";
      this.currentItemId = null;
      this.form = {
        nombres: "",
        correo: "",
        tipo_cliente: "",
        fecha_registro: this.getCurrentDate(),
        numero_documento: "",
        direccion: "",
        telefono: "",
        logo: "",
        boton_1: "",
        boton_2: "",
        boton_3: "",
        link_boton_1: "",
        link_boton_2: "",
        link_boton_3: "",
        banner_uno: "",
        banner_dos: "",
        link_banner_uno: "",
        link_banner_dos: "",
        estado: 1, // Siempre activo al crear
      };
      this.formErrors = {};
      this.file_uno = null;
      this.file_dos = null;
      this.file_logo = null;
      //Agregar referencias para que limpie los inputs de imagenes
      if (this.$refs.logoInput) this.$refs.logoInput.value = "";
      if (this.$refs.bannerUnoInput) this.$refs.bannerUnoInput.value = "";
      if (this.$refs.bannerDosInput) this.$refs.bannerDosInput.value = "";
      this.showModal();
    },

    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    handleFileUpload_logo(event) {
      //Cambiamos metodo apra que cree el url base 64
      const file = event.target.files[0];
      if (!file) return;
      this.file_logo = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.logo = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    handleFileUpload_uno(event) {
      //Cambiamos metodo apra que cree el url base 64
      const file = event.target.files[0];
      if (!file) return;
      this.file_uno = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.banner_uno = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    handleFileUpload_dos(event) {
      //Cambiamos metodo apra que cree el url base 64
      const file = event.target.files[0];
      if (!file) return;
      this.file_dos = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.banner_dos = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async fetchClientes() {
      try {
        this.cargando = true;
        const response = await Clienteservice.getClientes();
        this.clientes = response.data.data;
      } catch (error) {
        console.error("Error fetching clientes:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al cargar los clientes.",
        });
      } finally {
        this.cargando = false;
      }
    },

    verClientes(cliente) {
      const detalles = `
                <div style="display: flex; flex-wrap: wrap;">
                    <div style="flex: 1; min-width: 50%; text-align: left; padding-right: 10px;">
                        <p><strong>Nombre:</strong> ${cliente.nombres}</p>
                        <p><strong>Dirección:</strong> ${cliente.direccion}</p>                 
                        <p><strong>Logo:</strong> <img src="${cliente.logo}" alt="logo" width="100"></p>
                    </div>
                    <div style="flex: 1; min-width: 50%; text-align: left; padding-left: 10px;">
                        <p><strong>Teléfono:</strong> ${cliente.telefono}</p>
                        <p><strong>Correo:</strong> ${cliente.correo}</p>
                        <p><strong>Número de documento:</strong> ${cliente.numero_documento}</p>
                    </div>
                    <div style="flex: 1; min-width: 100%; text-align: left; padding-left: 10px;">
                        <hr>
                        <p><strong>Texto Botón 01:</strong> ${cliente.boton_1 || "N/A"}</p>                   
                        <p><strong>Enlace:</strong> ${cliente.link_boton_1 || "N/A"}</p>
                        <hr>
                        <p><strong>Texto Botón 02:</strong> ${cliente.boton_2 || "N/A"}</p>                   
                        <p><strong>Enlace:</strong> ${cliente.link_boton_2 || "N/A"}</p>
                        <hr>
                        <p><strong>Texto Botón 03:</strong> ${cliente.boton_3 || "N/A"}</p>                   
                        <p><strong>Enlace:</strong> ${cliente.link_boton_3 || "N/A"}</p>
                    </div>
                    <div style="flex: 1; min-width: 100%; text-align: left; padding-left: 10px;">
                        <hr>
                        <p><strong>Enlace Banner 01:</strong> ${cliente.link_banner_uno || "N/A"}</p>
                        ${cliente.banner_uno ? `<p><img src="${cliente.banner_uno}" alt="banner_uno" width="100"></p>` : ""}
                        <hr>
                        <p><strong>Enlace Banner 02:</strong> ${cliente.link_banner_dos || "N/A"}</p>
                        ${cliente.banner_dos ? `<p><img src="${cliente.banner_dos}" alt="banner_dos" width="100"></p>` : ""}
                    </div>
                </div>
            `;

      this.$swal({
        icon: "info",
        title: "Detalles del cliente",
        html: detalles,
        customClass: {
          popup: "swal-wide",
        },
        width: "50%",
      });
    },

    async guardarClientes() {
      const formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        if (key !== "logo" && key !== "banner_uno" && key !== "banner_dos") {
          formData.append(key, this.form[key]);
        }
      });

      if (this.file_logo) formData.append("logo", this.form.logo);
      if (this.file_uno) formData.append("banner_uno", this.form.banner_uno);
      if (this.file_dos) formData.append("banner_dos", this.form.banner_dos);

      this.cargando = true;
      try {
        if (!this.currentItemId) {
          // Crear nuevo cliente
          await Clienteservice.CrearCliente(formData);
          this.$swal({
            icon: "success",
            title: "Cliente Creado",
            text: "El cliente ha sido creado exitosamente.",
          });
        } else {
          // Actualizar cliente existente
          formData.append("_method", "PUT");
          await Clienteservice.updateCliente(this.currentItemId, formData);
          this.$swal({
            icon: "success",
            title: "Cliente Actualizado",
            text: "El cliente ha sido actualizado exitosamente.",
          });
        }

        this.closeModal();
        await this.fetchClientes();
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.formErrors = error.response.data.errors;
        } else {
          console.error("Error guardando:", error);
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Hubo un error al guardar el cliente.",
          });
        }
      } finally {
        this.cargando = false;
      }
    },

    editarClientes(cliente) {
      this.modalTitle = "Editar Cliente";
      this.currentItemId = cliente.id;

      this.form = {
        nombres: cliente.nombres,
        tipo_cliente: cliente.tipo_cliente,
        estado: cliente.estado,
        numero_documento: cliente.numero_documento,
        direccion: cliente.direccion,
        telefono: cliente.telefono,
        correo: cliente.correo,
        logo: cliente.logo,
        banner_dos: cliente.banner_dos,
        banner_uno: cliente.banner_uno,
        fecha_registro: cliente.fecha_registro.split(" ")[0], // Solo la fecha sin hora
        link_boton_1: cliente.link_boton_1 || "",
        link_boton_2: cliente.link_boton_2 || "",
        link_boton_3: cliente.link_boton_3 || "",
        link_banner_uno: cliente.link_banner_uno || "",
        link_banner_dos: cliente.link_banner_dos || "",
        boton_1: cliente.boton_1 || "",
        boton_2: cliente.boton_2 || "",
        boton_3: cliente.boton_3 || "",
      };

      this.file_logo = null;
      this.file_uno = null;
      this.file_dos = null;
      //Limpiamos los inputs de imagenes
      if (this.$refs.logoInput) this.$refs.logoInput.value = "";
      if (this.$refs.bannerUnoInput) this.$refs.bannerUnoInput.value = "";
      if (this.$refs.bannerDosInput) this.$refs.bannerDosInput.value = "";
      this.showModal();
    },

    showModal() {
      const modal = document.getElementById("principalModal");
      if (modal) {
        modal.classList.add("show");
        modal.style.display = "block";
        modal.setAttribute("aria-modal", "true");
        modal.removeAttribute("aria-hidden");
      }
    },

    closeModal() {
      const modal = document.getElementById("principalModal");
      if (modal) {
        modal.classList.remove("show");
        modal.style.display = "none";
        modal.setAttribute("aria-hidden", "true");
        modal.removeAttribute("aria-modal");
      }
      this.formErrors = {};
    },
  },
  mounted() {
    this.fetchClientes();
  },
};
</script>

<style></style>
